import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const FACILITY_SANTA_ANITA_PARK = "028d9bdc-0203-5876-5285-d567c0b3a25e";
export const FACILITY_GOLDEN_GATE_FIELDS =
  "d2571663-d691-642b-68ae-a020c9150875";
export const FACILITY_GULFSTREAM_PARK = "54b363f3-c596-301d-777f-4f2782d3bfb9";
export const FACILITY_PIMLICO = "f786ff44-8962-372d-d7cd-09bc6e5a2548";
export const FACILITY_LAUREL_PARK = "399d5d62-efcb-9acd-5b8d-6b1ce1692d78";
export const FACILITY_DEL_MAR = "66bf4c7c-9a63-5700-9fbe-70a881b13e79";

export const TRAINING_CENTER_SAN_LUIS_RAY =
  "28750e7a-406b-aa8b-ae01-88011ca147aa";
export const TRAINING_CENTER_PALM_MEADOWS =
  "2cfc9d06-e6c3-53d1-3ee3-191f1f785133";
export const TRAINING_CENTER_LOS_ALAMITOS =
  "41ae2df3-749d-bd0d-fbb4-d843908f5082";

export const mainTracks = [
  FACILITY_SANTA_ANITA_PARK,
  FACILITY_GOLDEN_GATE_FIELDS,
  FACILITY_GULFSTREAM_PARK,
  FACILITY_PIMLICO,
  FACILITY_LAUREL_PARK,
  FACILITY_DEL_MAR
];

export const onTrackHorses = [
  FACILITY_SANTA_ANITA_PARK,
  FACILITY_GULFSTREAM_PARK,
  TRAINING_CENTER_SAN_LUIS_RAY,
  TRAINING_CENTER_PALM_MEADOWS,
  TRAINING_CENTER_LOS_ALAMITOS,
  FACILITY_DEL_MAR
];

export const horsesToDisplayFilterTracks = [
  FACILITY_SANTA_ANITA_PARK,
  FACILITY_GULFSTREAM_PARK,
  FACILITY_DEL_MAR
];

export const allFacilitiesOption: racehorse360.IFacility = {
  id: "all",
  name: "All Tracks",
  code: "ALL",
  backgroundColor: "000000"
};

export const getFacilityOptions = (
  facilities: racehorse360.IFacility[],
  shouldDisplayAllTracksOption: boolean,
  shouldDisplayTrainingFacilities: boolean,
  shouldDisplayTsgFacilitiesOnly: boolean,
  customOptions?: racehorse360.IFacility[]
): racehorse360.IFacility[] => {
  if (!facilities?.length) {
    return [];
  }

  let result = [...facilities];

  if (shouldDisplayTrainingFacilities) {
    facilities
      .filter(f => f.trainingFacilities?.length)
      .forEach(f => {
        const activeTrainingFacilities = f.trainingFacilities.filter(
          tf => tf.active
        );
        result.push(...activeTrainingFacilities);
      });
  }

  if (shouldDisplayTsgFacilitiesOnly) {
    result = [
      ...result.filter(
        f => f.scope === racehorse360.FacilityScope.FACILITY_SCOPE_TSG
      )
    ];
  }

  result = [...new Map(result.map(f => [f.id, f])).values()].sort((f1, f2) =>
    f1.code.localeCompare(f2.name)
  );

  const santaAnitaFacilityIndex = result.findIndex(
    item => item.id === FACILITY_SANTA_ANITA_PARK
  );

  if (santaAnitaFacilityIndex !== -1) {
    const [item] = result.splice(santaAnitaFacilityIndex, 1);

    result = [item, ...result];
  }

  if (shouldDisplayAllTracksOption) {
    result.unshift(allFacilitiesOption);
  }

  if (customOptions?.length) {
    result.push(...customOptions);
  }

  return result;
};

export const getShortenedFacilityName = (
  facility: racehorse360.IFacility
): string => {
  if (!facility) return;

  return (facility.shortName || facility.name)?.toLocaleLowerCase();
};
